import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
  const action = route.meta.action || 'read';
  const resource = route.meta.resource;

  // 如果 action 是陣列，檢查是否有任何一個權限
  if (Array.isArray(action)) {
    return action.some(act => ability.can(act, resource));
  }

  // 單一權限檢查
  return ability.can(action, resource);
})

export const _ = undefined
